import { render } from "./ModalRememberTwo.vue?vue&type=template&id=5d5a6135&scoped=true&ts=true"
import script from "./ModalRememberTwo.vue?vue&type=script&lang=ts"
export * from "./ModalRememberTwo.vue?vue&type=script&lang=ts"

import "./ModalRememberTwo.vue?vue&type=style&index=0&id=5d5a6135&lang=scss&scoped=true"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5a6135"]])

export default __exports__